import { styled } from '../../modules';

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    max-width: calc(100vh * 3 / 4);
    background-color: #ffffff;
    overflow-y: auto;
`;

export const LogoSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 24px;
    border-bottom: 1px solid #e5e5e5;
`;

export const LogoImage = styled.img`
    max-height: 52px;
    max-width: 200px;
    object-fit: contain;
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    padding: 32px 24px 24px;
    gap: 24px;
`;

export const IntroSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Title = styled.h1<{ $color: string }>`
    font-size: 26px;
    font-weight: 600;
    color: ${({ $color }) => $color};
    margin: 0;
    line-height: 1.3;
    text-align: center;
`;

export const Subtitle = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #444;
    margin: 0;
    line-height: 1.6;
    text-align: left;
`;

export const FormFieldsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SubmitButton = styled.button<{ $backgroundColor: string; $disabled: boolean }>`
    width: 100%;
    padding: 16px 20px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    background-color: ${({ $backgroundColor, $disabled }) => $disabled ? '#aaa' : $backgroundColor};
    cursor: ${({ $disabled }) => $disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: opacity 0.2s;

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`;

export const Footer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px 24px 24px;
`;
